const enumEstiloStatus = {
  textoEstilo: "",
  estiloTexto: {
    color: "white",
    background: "rgb(0, 153, 93)",
    "border-radius": "30px",
    padding: "4px 12px",
    width: "130px",
    "text-align": "center"
  }
};

export const enumStatusPrestadorNome = {
  ATIVO: "ATIVO",
  PENDENTE: "PENDENTE",
  EM_ANALISE: "EM_ANALISE",
  EXCLUSAO_PROGRAMADA: "EXCLUSAO_PROGRAMADA",
  EXCLUIDO: "EXCLUIDO",
  LEITOS: "LEITOS",
  ATIVO_UN_OPS: "ATIVO_UN_OPS",
  PENDENTE_UN_OPS: "PENDENTE_UN_OPS",
  EM_ANALISE_UN_OPS: "EM_ANALISE_UN_OPS",
  EXCLUSAO_PROGRAMADA_UN_OPS: "EXCLUSAO_PROGRAMADA_UN_OPS",
  EXCLUIDO_UN_OPS: "EXCLUIDO_UN_OPS"
};

export const enumStatusPrestador = {
  [enumStatusPrestadorNome.SEM_JUSTIFICATIVA]: {
    textoExibicao: "Ativo",
    textoEstilo: "Ativo",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#245F40",
      "margin-right": "16px",
      display: "inline-block"
    },
    icones: [
      {
        icone: "alert-triangle",
        tamanho: 20,
        feather: true,
        tooltip: "",
        direcaoEsquerda: true,
        style: {
          color: "#ED1651"
        }
      }
    ],
    estiloIcones: {
      display: "inline-block",
      top: "4px",
      position: "relative"
    }
  },
  [enumStatusPrestadorNome.EXCLUSAO_PROGRAMADA]: {
    textoExibicao: "Ativo",
    textoEstilo: "Ativo",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#245F40",
      "margin-right": "16px",
      display: "inline-block"
    },
    icones: [
      {
        icone: "alert-triangle",
        tamanho: 20,
        feather: true,
        tooltip: "",
        direcaoEsquerda: true,
        style: {
          color: "#ED1651"
        }
      }
    ],
    estiloIcones: {
      display: "inline-block",
      top: "4px",
      position: "relative"
    }
  },
  [enumStatusPrestadorNome.EM_ANALISE]: {
    textoExibicao: "Em análise",
    textoEstilo: "Em análise",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      color: "#60656C",
      background: "#DEE2E6"
    }
  },
  [enumStatusPrestadorNome.LEITOS]: {
    textoExibicao: "-",
    textoEstilo: "Leitos",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      color: "#60656C",
      background: "#DEE2E6"
    }
  },
  [enumStatusPrestadorNome.PENDENTE]: {
    textoExibicao: "Pendente",
    textoEstilo: "Pendente",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      color: "#4D3D02",
      background: "#FFCB08"
    }
  },
  [enumStatusPrestadorNome.ATIVO]: {
    textoExibicao: "Ativo",
    textoEstilo: "Ativo",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto
    }
  },
  [enumStatusPrestadorNome.EXCLUIDO]: {
    textoExibicao: "Excluido",
    textoEstilo: "Excluido",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#ED1651"
    },
    // TEXTO TOOLTIP
    texto: ""
  },
  [enumStatusPrestadorNome.ATIVO_UN_OPS]: {
    textoExibicao: "Ativo - Prestador UN-OPS",
    textoEstilo: "Ativo",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#82edb0"
    }
  },
  [enumStatusPrestadorNome.PENDENTE_UN_OPS]: {
    textoExibicao: "Pendente - Prestador UN-OPS",
    textoEstilo: "Pendente",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      color: "#4D3D02",
      background: "#feffa3"
    }
  },
  [enumStatusPrestadorNome.EM_ANALISE_UN_OPS]: {
    textoExibicao: "Em Análise - Prestador UN-OPS",
    textoEstilo: "Em análise",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      color: "#60656C",
      background: "	#dbdcff"
    }
  },
  [enumStatusPrestadorNome.EXCLUIDO_UN_OPS]: {
    textoExibicao: "Excluído - Prestador UN-OPS",
    textoEstilo: "Excluido",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#ffb3ba"
    },
    // TEXTO TOOLTIP
    texto: ""
  },
  [enumStatusPrestadorNome.EXCLUSAO_PROGRAMADA_UN_OPS]: {
    textoExibicao: "Ativo",
    textoEstilo: "Ativo",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#245F40",
      "margin-right": "16px",
      display: "inline-block"
    },
    icones: [
      {
        icone: "alert-triangle",
        tamanho: 20,
        feather: true,
        tooltip: "",
        direcaoEsquerda: true,
        style: {
          color: "#ED1651"
        }
      }
    ],
    estiloIcones: {
      display: "inline-block",
      top: "4px",
      position: "relative"
    }
  }
};
